"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.hilSubModelEditorStateSchema = exports.edgeAnchorSchema = exports.hilSubModelMetadataSchema = exports.HilSigmaSignalLayout = void 0;
const z = __importStar(require("zod"));
var HilSigmaSignalLayout;
(function (HilSigmaSignalLayout) {
    HilSigmaSignalLayout["Left"] = "left";
    HilSigmaSignalLayout["Right"] = "right";
    HilSigmaSignalLayout["Split"] = "split";
    HilSigmaSignalLayout["Custom"] = "custom";
})(HilSigmaSignalLayout || (exports.HilSigmaSignalLayout = HilSigmaSignalLayout = {}));
exports.hilSubModelMetadataSchema = z.object({
    graphPosition: z
        .object({
        x: z.number(),
        y: z.number(),
    })
        .optional(),
    signalLayout: z.nativeEnum(HilSigmaSignalLayout).optional(),
    signalSides: z.record(z.string(), z.enum(['left', 'right'])).optional(),
});
exports.edgeAnchorSchema = z.object({
    edge: z.enum(['top', 'right', 'bottom', 'left']),
    t: z.number().min(0).max(1),
});
exports.hilSubModelEditorStateSchema = z.object({
    canvas: z
        .object({
        signalPositions: z.record(z.string(), exports.edgeAnchorSchema).optional(),
    })
        .optional(),
});
//# sourceMappingURL=hil-sub-model-metadata.js.map